import SlipShareService from '@pages/SlipShareService.vue'

export default [
  {
    path: '/slip-share-service',
    name: 'SlipShareService',
    component: SlipShareService,
    meta: {
      // Superuser only. Enforced by the vue-router-user-roles library (see
      // main.js): a non-superuser (Guest/Member/Company) is denied and
      // redirected to the Dashboard.
      permissions: [
        {
          role: 'Guest',
          access: false,
          redirect: 'Home'
        },
        {
          role: 'Member',
          access: false,
          redirect: 'Dashboard'
        },
        {
          role: 'Company',
          access: false,
          redirect: 'Dashboard'
        }
      ]
    }
  }
]
